"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSessionStorageSupported = void 0;
const TEST = 'test';

// eslint-disable-next-line import/no-mutable-exports -- needed
let isSessionStorageSupported = () => {
  try {
    sessionStorage.setItem(TEST, TEST);
    sessionStorage.removeItem(TEST);
    exports.isSessionStorageSupported = isSessionStorageSupported = () => true;
    return isSessionStorageSupported();
  } catch (error) {
    exports.isSessionStorageSupported = isSessionStorageSupported = () => false;
    return isSessionStorageSupported();
  }
};
exports.isSessionStorageSupported = isSessionStorageSupported;
//# sourceMappingURL=isSessionStorageSupported.js.map